"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var schemaPath_1 = require("./schemaPath");
var fixAndMergeSchema_1 = require("./fixAndMergeSchema");
/**
 * zwraca płaską listę elementów schematu
 *
 * @export
 * @param {JSONSchema} schema schemat
 * @param {boolean} [sipleTypesOnly=false] czy zwracać tylko typy proste (pomija object i array)
 * @param {FlatPropsListItem[]} [prevList=[]] dane wewnętrzne
 * @returns {FlatPropsListItem[]} lista zwróconych właściwości
 */
function flatPropsList(schema, sipleTypesOnly, prevList) {
    if (sipleTypesOnly === void 0) { sipleTypesOnly = false; }
    if (prevList === void 0) { prevList = []; }
    if (schema.$parent === undefined) {
        schema = fixAndMergeSchema_1.default([schema]);
    }
    if (schema.$key) {
        if (sipleTypesOnly) {
            if (schema.type !== 'object' && schema.type !== 'array') {
                prevList.push({
                    path: schemaPath_1.default(schema, true).replace('[]', ''),
                    field: schema.$key,
                    schema: schema
                });
            }
        }
        else {
            prevList.push({
                path: schemaPath_1.default(schema, true),
                field: schema.$key,
                schema: schema
            });
        }
    }
    if (schema.type === 'object') {
        if (schema.properties) {
            // tslint:disable-next-line: forin
            for (var propName in schema.properties) {
                flatPropsList(schema.properties[propName], sipleTypesOnly, prevList);
            }
        }
    }
    else if (schema.type === 'array') {
        if (schema.items) {
            flatPropsList(schema.items, sipleTypesOnly, prevList);
        }
    }
    return prevList;
}
exports.default = flatPropsList;
//# sourceMappingURL=flatPropsList.js.map